export const spaces = {
  1: '8px',
  2: '10px',
  3: '20px',
  4: '30px',
  5: '40px',
};